module.exports = __webpack_public_path__ + "img/26824.613bcadf.svg";